import React from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import "./maida.css";
import ProductCard from "../../components/productCard/ProductCard";
import Img1 from "./img1.png";
import Img2 from "./img2.png";
import Img3 from "./img3.png";
import SingleRecipiePage from "../../components/singleRecipiePage/SingleRecipiePage";

const Maida = () => {
  return (
    <>
      <Navb />
      <div className="maidamaintop">
        <div className="daliatoptext">
        "Nandi Maida: Wholesome <br /> Goodness in Every Grain, Every <br /> Bite."

        </div>
        <img
          src={Img2}
          alt="Img2"
          style={{ display: "block", padding: "8px 50px 0px" }}
        />
      </div>

      <div className="whiteComponentsingleEcavo bg5">
        <SingleRecipiePage
          currrentImg={Img3}
          heading="NANDI Maida"
          text="Nandi's Maida, a premium flour that promises superior quality and versatility in your kitchen. Made from the finest wheat grains, Nandi's Maida is meticulously processed to deliver a smooth texture and excellent baking properties. Whether you're baking fluffy cakes, crispy cookies, or indulgent pastries. Elevate your baking experience with Nandi's Maida, trusted by chefs and home bakers alike for its unmatched performance and delicious outcomes."
          link1="/recipes/mixvegparatha"
          link1Text="View Recipes"
          link2="https://ecavo.shop/products/maida-500gm"
          linkClass="blackButton"
          //   sideImg={Sideimg1}
          headingcss="blackHeading"
          pcss="blackP"
        />
      </div>
      <div className="productCards">
        <ProductCard
          Heading="Versatility"
          Text="Nandi's Maida is incredibly versatile, making it suitable for a wide range of baking applications. Whether you're making bread, biscuits, or pies, this flour can adapt to various recipes, providing excellent structure and texture to your baked treats."
        />
        <ProductCard
          Heading="Fine Texture"
          Text="With its finely milled texture, Nandi's Maida guarantees a smooth and velvety consistency in baked goods. This fine texture contributes to lighter and fluffier cakes, pastries, and other delicacies, enhancing their overall appeal."
        />
        <ProductCard
          Heading="Consistent Quality"
          Text="Nandi's Maida is renowned for its consistent quality, ensuring that every batch maintains the same high standards. This reliability allows chefs and bakers to achieve predictable and excellent results in their culinary creations."
        />
      </div>
      <Footer />
    </>
  );
};

export default Maida;
